module.exports = __webpack_public_path__ + "static/media/Andrea_Campagnoli.1516da95.jpg";